module.exports = __webpack_public_path__ + "src/assets/games/34/TUBES028.jpg";